<template>
    <div class="container mt-5">
        <div class="row">
            <div class="col-12 text-center">
                <img src="/assets/dipocaco/logo_big_text.png" alt="" class="logo">
            </div>

            <div class="col-12 mt-3" v-if="errorMessage.length">
                <div class="alert alert-danger">
                    {{ errorMessage }}
                </div>
            </div>

            <div class="col-12 mt-3" v-if="errors.length > 0">
                <div class="alert alert-danger" v-for="error in errors">
                    {{ error }}
                </div>
            </div>

            <div class="col-12" v-if="hasAccount">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" name="username" class="form-control" v-model="username">
                    <span v-if="getErrorForField('username')" v-text="getErrorForField('username')" class="text-danger"></span>
                </div>

                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" name="password" class="form-control" v-model="password" v-on:keyup.enter="attemptLogin">
                    <span v-if="getErrorForField('password')" v-text="getErrorForField('password')" class="text-danger"></span>
                </div>

                <div class="form-group row">
                    <div class="col-6 p-1">
                        <a href="javascript:" class="btn btn-dark w-100 mr-1" v-on:click="hasAccount = false;">Register</a>
                    </div>

                    <div class="col-6 p-1">
                        <a href="javascript:" class="btn btn-success w-100 ml-1" v-on:click="attemptLogin">Login</a>
                    </div>
                </div>
            </div>

            <div class="col-12" v-else>
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" name="username" :class="'form-control '+(Object.keys(errors).includes('username') ? 'is-invalid' : '')" v-model="username">
                    <span v-if="getErrorForField('username')" v-text="getErrorForField('username')" class="text-danger"></span>
                </div>

                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" name="password" :class="'form-control '+(Object.keys(errors).includes('password') ? 'is-invalid' : '')" v-model="password">
                    <span v-if="getErrorForField('password')" v-text="getErrorForField('password')" class="text-danger"></span>
                </div>

                <div class="form-group">
                    <label for="password_confirmation">Repeat password</label>
                    <input type="password" name="password_confirmation" :class="'form-control '+(Object.keys(errors).includes('password_confirmation') ? 'is-invalid' : '')" v-model="password_confirmation">
                    <span v-if="getErrorForField('password_confirmation')" v-text="getErrorForField('password_confirmation')" class="text-danger"></span>
                </div>

                <div class="form-group">
                    <label for="serial-key">Serial key</label>
                    <input type="text" name="serial-key" :class="'form-control '+(Object.keys(errors).includes('serial-key') ? 'is-invalid' : '')" v-model="serialKey">
                    <span v-if="getErrorForField('serial-key')" v-text="getErrorForField('serial-key')" class="text-danger"></span>
                </div>

                <div class="form-group row">
                    <div class="col-6 p-1">
                        <a href="javascript:" class="btn btn-dark w-100" v-on:click="hasAccount = true;">Login</a>
                    </div>

                    <div class="col-6 p-1">
                        <a href="javascript:" class="btn btn-success w-100" v-on:click="register">Register</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "Landing",
    data() {
        return {
            hasAccount: true,
            username: '',
            password: '',
            passwordRepeat: '',
            serialKey: '',
            restoreToken: '',
            errors: [],
            loggedIn: false,
            loginResponse: false,
            errorMessage: '',
        };
    },
    mounted() {
        // document.body.dataset.bsTheme = 'light';

        if (window.Laravel.auth) {
            this.$router.push('home');
        }
    },
    computed: {
        csrfToken() {
            return document.getElementsByName('_token').value
        }
    },
    watch: {
        loggedIn(val, prevVal) {
            if (val === true) {
                this.$store.commit('loginSuccess', this.loginResponse);
                this.$router.push({name: 'dashboard'});
            }
        }
    },
    methods: {
        getErrorForField(fieldName) {
            if (Object.keys(this.errors).includes(fieldName)) {
                return this.errors[fieldName][0];
            }

            return false;
        },
        attemptLogin() {
            this.errors = [];
            this.errorMessage = '';

            axios.post('/login', {
                username: this.username,
                password: this.password,
                _token: window.Laravel.csrfToken
            }).then((response) => {
                window.location.reload();
            }).catch((error) => {
                console.log(error.response.data)
                if (error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach(field => {
                        error.response.data.errors[field].forEach(field => {
                            this.errors.push(field)
                        })
                    });
                }
            })
        },
        register() {
            this.errors = [];

            axios.post('/register', {
                username: this.username,
                password: this.password,
                password_confirmation: this.password_confirmation,
                serialKey: this.serialKey,
                _token: window.Laravel.csrfToken
            }).then((response) => {
                this.hasAccount = true;
                this.attemptLogin();
            }).catch((error) => {
                if (error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach(field => {
                        error.response.data.errors[field].forEach(field => {
                            this.errors.push(field)
                        })
                    });
                }
            })
        }
    },
};
</script>


<style scoped lang="scss">
.container {
    max-width: 600px;
}

.form-group {
    margin-bottom: 1em;
}

.logo {
    max-height: 14em;
}
</style>
